import numeral from "numeral";
import Vue from "vue";

Vue.filter('n2', value => {
    if (value) {
        return numeral(value).format("0,0.00");
    }
    return "";
})
